import * as d3 from 'd3';

const curveFunction = d3.curveBasis


export const dagreConfig = {
    graph: {

    },
    node: {
        width: 400,
        height: 100
    },
    edge: {
        document: {
            curve: curveFunction,
            stroke: 'red',
            weight: 4,
            // width: 250,
            class: 'link-document',
            minLen: 3,
            arrowheadStyle: 'display: none',
        },
        organization: {
            curve: curveFunction,
            class: 'link-organization',
            minLen: 3,
            weight: 3,
            arrowheadStyle: 'display: none',
        },
        organizationStrong: {
            curve: curveFunction,
            class: 'link-organization-strong',
            minLen: 3,
            stroke: 'blue',
            weight: 5,
            arrowheadStyle: 'display: none',
        },
        organizationWeak: {
            curve: curveFunction,
            class: 'link-organization-weak',
            minLen: 1,
            stroke: 'yellow',
            weight: 1,
            arrowheadStyle: 'display: none',
        },
        person: {
            curve: curveFunction,
            class: 'link-person',
            arrowheadStyle: 'display: none',
        },
        bundle: {
            curve: curveFunction,
            class: 'link-bundle',
            arrowheadStyle: 'display: none',
        }

    }

}